// Editable Field
export default angular.module('editableField', [])
    .factory('EditableFieldsService', require('./editablefieldsservice'))
    .controller('EditableFieldController', require('./editablefieldcontroller'))
    .directive('editableFieldGroup', require('./editablefieldgroupdirective'))
    .directive('formInput', require('./editablefieldinputdirective'))
    .directive('editableFieldEdit', require('./editdirective'))
    .directive('editableFieldSave', require('./savedirective'))
    .directive('editableFieldCancel', require('./canceldirective'));
